import { initializeApp } from "firebase/app";
import { collection, getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from 'firebase/database';
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBxtv6j3KqsvO_RWfGeYHqqzPqMRjmb4D0",
  authDomain: "viznexa.firebaseapp.com",
  projectId: "viznexa",
  storageBucket: "viznexa.appspot.com",
  messagingSenderId: "309071304339",
  appId: "1:309071304339:web:c30fb5d77241b746bedf66"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);

export const databse = getDatabase(app);

export const colRef = collection(db, "cards");

export const storage = getStorage(app);